module.exports = __webpack_public_path__ + "fonts/Sarabun-Italic.e6f60ba9.ttf";